import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StateService } from '../shared/services/state.service';
import { SessionService } from '../shared/services/session.service';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  public mydevice: string = "";
  slidestatus: boolean = true;
  show: boolean = true;
  errorMessage: string;
  public bloburl: string;
  constructor(private route: ActivatedRoute,
    private stateService: StateService, private sessionService: SessionService) {
    this.bloburl = this.sessionService.bloburl;
  }
  ngOnInit() {

    var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var userAgent = navigator.userAgent.toLowerCase();
    var android_dev = userAgent.indexOf("android") > -1;
    var chrome_browser = userAgent.indexOf("chrome") > -1;
    var samsung_browser = userAgent.indexOf("samsung") > -1;

    if (isIOS) {
      this.mydevice = "ipad";
    }
    else if (android_dev) {
      this.mydevice = "android";

      if (samsung_browser) {
        this.mydevice = this.mydevice + "_samsung";
      }
      else if (chrome_browser) {
        this.mydevice = this.mydevice + "_chrome";

      }
      var body = document.body;
      body.classList.add(this.mydevice);
    }

    this.popup();

    this.route.queryParamMap.subscribe(params => {
      var licenseId = params.get("licenseId");
      if (licenseId) {

        this.stateService.setLicenseId(licenseId);        
      } else {
        if (!this.stateService.getLicenseId()) { 
          this.errorMessage = "Missing licenseId in call";          
        }
      }
    })

  }
  popup() {
    //popup1

    let colofonmodal = document.getElementById('myModalcolofon');

    // Get the button that opens the modal
    let colofonclickarea = document.getElementById("colofon");

    // Get the <span> element that closes the modal
    let colofonclosebutton: any = document.getElementsByClassName("colofonclose")[0];

    // When the user clicks the button, open the modal 

    colofonclickarea.onclick = function () {
      colofonmodal.style.display = "block";
    }
    colofonclosebutton.onclick = function () {
      colofonmodal.style.display = "none";
    }
  }
}
